import { useContext } from 'react'
import { ViewportContext } from './DataContext'

export const useViewportContext = () => {
  const context = useContext(ViewportContext)

  if (context === undefined) {
    throw new Error('useViewportContext must be used within DataContextProvider')
  }

  return context
}
